<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">No Escrow</h1>

        <section class="content-section">
            <p class="desc-text">XigCheck does not hold customer funds, provide escrow services, custody user funds, or operate stored-value accounts.</p>
            <p class="desc-text">All payment processing activities are handled separately through approved third-party payment service providers operating under their own compliance and regulatory frameworks.</p>
        </section>

        <section class="content-section">
            <p class="desc-text">XigCheck authentication services are independent from payment settlement functions and are limited to product review support and marketplace trust procedures.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckNoEscrow'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
